import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, defineAsyncComponent } from 'vue';
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  setup(__props) {

const homeStore = useHomeStore();
const OldSummary = defineAsyncComponent(() => import('./OldSummary.vue'));
const NewSummary = defineAsyncComponent(() => import('./NewSummary.vue'));

const SHOWVIEW = {
  OLDSUMMARY: true,
  NEWSUMMARY: false,
};
const showVersion = computed(() => (homeStore.isNewVersion ? SHOWVIEW.NEWSUMMARY : SHOWVIEW.OLDSUMMARY));

return (_ctx: any,_cache: any) => {
  return (_unref(showVersion))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(OldSummary))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(NewSummary))
      ]))
}
}

})